import { Phone, MessageCircle } from "lucide-react";
import { useSite } from "@/lib/site";

export default function StickyActions() {
  const { site } = useSite();
  if (!site) return null;
  const wa = site.whatsapp_number?.replace(/\D/g, "");
  const phone = site.phone_primary;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex flex-col gap-3 items-end">
      {wa && (
        <a
          data-testid="sticky-whatsapp"
          href={`https://wa.me/${wa}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          className="h-14 w-14 sm:h-16 sm:w-16 bg-[#25D366] hover:bg-[#1eb858] text-white flex items-center justify-center shadow-lg transition-all duration-150 hover:scale-105"
        >
          <MessageCircle size={26} strokeWidth={2.2} />
        </a>
      )}
      {phone && (
        <a
          data-testid="sticky-call"
          href={`tel:${phone}`}
          aria-label="Call"
          className="h-14 w-14 sm:h-16 sm:w-16 bg-brand-red hover:bg-brand-redHover text-white flex items-center justify-center shadow-lg transition-all duration-150 hover:scale-105"
        >
          <Phone size={24} strokeWidth={2.2} />
        </a>
      )}
    </div>
  );
}
